import React, { lazy } from 'react';
import registry from '~/library/store/src/registry';

const TradeDocumentationComponent = lazy(
  () =>
    (import(
      /* webpackChunkName: "carvana-purchase-trade-documentation" */ '@carvana/purchase-trade-documentation'
    ) as unknown) as Promise<{ default: React.ComponentType<any> }>
);

const defaultProps = {
  GetDashboardAndRouteToNextStep: (_?: boolean) => {}
};

export const TradeDocumentationRoute = ({
  GetDashboardAndRouteToNextStep
} = defaultProps) => {
  return (
    <TradeDocumentationComponent
      registry={registry}
      dashboardActions={{
        GetDashboardAndRouteToNextStep
      }}
    />
  );
};
